export const SET_MANGOPAY_SELECTED_CURRENCY = "SET_MANGOPAY_SELECTED_CURRENCY";
